import React, { Component, useState, useRef } from 'react'
import { CardDeck, Row, Col, Container, Card, Button, OverlayTrigger, Popover, Overlay } from 'react-bootstrap'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'bootstrap/dist/css/bootstrap.css';
import FeatherIcon from 'feather-icons-react';
class AdvanceTableWithOutExport extends React.Component {
      constructor(props) {
        super(props);
        debugger;
        console.log(this.props.data)
        this.dt = React.createRef();
       
        console.log(this.props.data)

          this.state = {

            globalSearchBox: '',

            data: this.props.data,
            columns: this.props.columns,
            // data: [
            //     { "id": "1000", "code": "f230fh0g3", "name": "Bamboo Watch", "description": "Product Description", "image": "bamboo-watch.jpg", "price": 65, "category": "Accessories", "quantity": 24, "inventoryStatus": "INSTOCK", "rating": 5 },
            //     { "id": "1001", "code": "nvklal433", "name": "Black Watch", "description": "Product Description", "image": "black-watch.jpg", "price": 72, "category": "Accessories", "quantity": 61, "inventoryStatus": "INSTOCK", "rating": 4 },
            //     { "id": "1002", "code": "zz21cz3c1", "name": "Blue Band", "description": "Product Description", "image": "blue-band.jpg", "price": 79, "category": "Fitness", "quantity": 2, "inventoryStatus": "LOWSTOCK", "rating": 3 },
            //     { "id": "1003", "code": "244wgerg2", "name": "Blue T-Shirt", "description": "Product Description", "image": "blue-t-shirt.jpg", "price": 29, "category": "Clothing", "quantity": 25, "inventoryStatus": "INSTOCK", "rating": 5 },
            //     { "id": "1004", "code": "h456wer53", "name": "Bracelet", "description": "Product Description", "image": "bracelet.jpg", "price": 15, "category": "Accessories", "quantity": 73, "inventoryStatus": "INSTOCK", "rating": 4 },
            //     { "id": "1005", "code": "av2231fwg", "name": "Brown Purse", "description": "Product Description", "image": "brown-purse.jpg", "price": 120, "category": "Accessories", "quantity": 0, "inventoryStatus": "OUTOFSTOCK", "rating": 4 },
            //     { "id": "1006", "code": "bib36pfvm", "name": "Chakra Bracelet", "description": "Product Description", "image": "chakra-bracelet.jpg", "price": 32, "category": "Accessories", "quantity": 5, "inventoryStatus": "LOWSTOCK", "rating": 3 },
            //     { "id": "1007", "code": "mbvjkgip5", "name": "Galaxy Earrings", "description": "Product Description", "image": "galaxy-earrings.jpg", "price": 34, "category": "Accessories", "quantity": 23, "inventoryStatus": "INSTOCK", "rating": 5 },
            //     { "id": "1008", "code": "vbb124btr", "name": "Game Controller", "description": "Product Description", "image": "game-controller.jpg", "price": 99, "category": "Electronics", "quantity": 2, "inventoryStatus": "LOWSTOCK", "rating": 4 },
            //     { "id": "1009", "code": "cm230f032", "name": "Gaming Set", "description": "Product Description", "image": "gaming-set.jpg", "price": 299, "category": "Electronics", "quantity": 63, "inventoryStatus": "INSTOCK", "rating": 3 }
            // ],
            // columns: [
            //   {"HeaderText":"Id", "MappingColomn":"id"},
            //   {"HeaderText":"Code", "MappingColomn":"code"},
            //   {"HeaderText":"Name","MappingColomn":"name"},
            //   {"HeaderText":"Description","MappingColomn":"description"},
            //   {"HeaderText":"Company","MappingColomn":"image"},
            //   {"HeaderText":"Category","MappingColomn":"category"}
            // ],
            PageSize: 10
        };

        this.onChange = this.onChange.bind(this);
        this.exportCSV = this.exportCSV.bind(this);
        this.saveAsExcelFile = this.saveAsExcelFile.bind(this);
        this.exportExcel = this.exportExcel.bind(this);
    }

    onChange(e) {
        console.log(e.target.value);
        this.setState(
            { [e.target.name]: e.target.value }
        )

    }

    exportCSV = () => {
        this.dt.current.exportCSV({});
    }

    exportPdf = () => {
        const exportColumns = this.state.columns.map(col => ({ title: col.HeaderText, dataKey: col.MappingColomn }));
        import('jspdf').then(jsPDF => {
            import('jspdf-autotable').then(() => {
                const doc = new jsPDF.default(0, 0);
                doc.autoTable(exportColumns, this.state.data);
                doc.save('ExportedFile.pdf');
            })
        })
    }

    // exportExcel = () => {

    //     import('xlsx').then(xlsx => {
    //         let ws = xlsx.utils.json_to_sheet(this.state.data);
    //         // const worksheet = xlsx.utils.json_to_sheet(this.dt);
    //         const worksheet = xlsx.utils.json_to_sheet(this.state.data);
    //         const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    //         const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
    //         this.saveAsExcelFile(excelBuffer, 'ExportedFile');
    //     }
    //     );
    // }

    exportExcel = () => {
        import('xlsx').then((xlsx) => {
          const exportData = this.state.data.map((item) => {
            const exportedItem = {};
            this.state.columns.forEach((col) => {
              exportedItem[col.HeaderText] = item[col.MappingColomn];
            });
            return exportedItem;
          });
      
          const worksheet = xlsx.utils.json_to_sheet(exportData);
          const workbook = {
            Sheets: { data: worksheet },
            SheetNames: ['data'],
          };
          const excelBuffer = xlsx.write(workbook, {
            bookType: 'xlsx',
            type: 'array',
          });
          this.saveAsExcelFile(excelBuffer, 'ExportedFile');
        });
      };
      

    saveAsExcelFile = (buffer, fileName) => {
        import('file-saver').then(FileSaver => {
            let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            let EXCEL_EXTENSION = '.xlsx';
            const data = new Blob([buffer], {
                type: EXCEL_TYPE
            });
            FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
        });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({data: nextProps.data})
      }


    render() {
        const {data} = this.state;
        return (
            <>

                {/* <Card>
                     <Card.Body>
                         <Container> */}
                <div class="d-flex pb-3"  style={{justifyContent:"right"}} >
                    <div className="btn-group" style={{display:"none"}}>
                        <Button onClick={this.exportExcel}>Excel</Button>
                        <Button onClick={this.exportPdf}>PDF</Button>
                    </div>
                    <div>
                        <input type="text" className="form-control" id="user-name" name="globalSearchBox" placeholder="Search..." onChange={this.onChange} />
                    </div>

                </div>
                <DataTable ref={this.dt} class="Table" value={this.state.data} 
                //paginator rows={this.state.PageSize} 
                sortMode="multiple" globalFilter={this.state.globalSearchBox} >
                    {
                        this.state.columns.map(
                            (item, index) => (
                                <Column field={item.MappingColomn} header={item.HeaderText} sortable></Column>)
                        )
                    }
                </DataTable>
            </>
        );
    }
}

export default AdvanceTableWithOutExport;


